import { ProductInfoRating } from '@/app/[locale]/product/[slug]/_components/product-info/product-info-rating'
import { formatCompactCount } from '@/lib/utils'
import { ProductDetailFormatted } from '@/types/product-detail'
import { useTranslations } from 'next-intl'

export const InfoRatingShort = ({
  product,
}: {
  product: ProductDetailFormatted
}) => {
  const t = useTranslations('product_detail.title')
  if (!product || product.review.avg <= 0 || product.review.count <= 0)
    return null

  return (
    <div className='flex flex-col gap-3 border-l border-l-neutral-200 px-2 py-4 2xl:pl-6'>
      <ProductInfoRating
        rating={product.review}
        wrapperClassName='gap-6 flex-wrap gap-y-1'
        showText={false}
      />
      {product.sold_product > 0 ? (
        <p className='font-sans text-sm leading-4.5 text-neutral-600'>
          {t('sold_product')} (web): {formatCompactCount(product.sold_product)}
        </p>
      ) : null}
    </div>
  )
}
